import { render, staticRenderFns } from "./PurchaseUnit.vue?vue&type=template&id=4fcbe7b3&"
import script from "./PurchaseUnit.vue?vue&type=script&lang=js&"
export * from "./PurchaseUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports